'use client';
import { useEffect, useState } from 'react';

export const useTheme = () => {
  const [theme, setTheme] = useState('');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    document.documentElement.classList.add(savedTheme || 'light');
  }, []);

  const handleTheme = () => {
    const isDark = document.documentElement.classList.contains('dark');
    localStorage.setItem('theme', isDark ? 'light' : 'dark');

    document.documentElement.classList.toggle('dark', !isDark);
    setTheme(isDark ? 'light' : 'dark');
  };

  return { theme, handleTheme };
};
